import React from "react";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { Link } from "react-router-dom";

const AdminButton = () => {
  return (
    <div style={{ textAlign: "right", paddingRight: "10px" }}>
      <Link to="/adminpanel">
        <div>
          <AdminPanelSettingsIcon color={"info"} />
        </div>
      </Link>
    </div>
  );
};
export default AdminButton;
